/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainerNotListed_similarGridItems = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainerNotListed_similarGridItems",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_similarItems",
      "args": null
    }
  ],
  "type": "moreLikeThisConnection"
};

module.exports = fragment;
